import type { RouterProps } from 'contracts/Router';
import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import { BASE_INVENTORY_2_PATH, INVENTORY_2_ROUTES } from 'lib/routes';
import { ImportFilesPage } from 'pages/inventory-2';

export const inventory2Routes = ({
  location,
  userBelongsToAnyOf,
}: RouterProps): RouteObject => {
  const allowed = userBelongsToAnyOf('admin', 'warehouseMember', 'planner');
  const Fallback = <Navigate to={'/'} state={{ from: location }} />;

  return {
    path: BASE_INVENTORY_2_PATH,
    element: allowed ? <Outlet /> : Fallback,
    children: [
      {
        path: INVENTORY_2_ROUTES.importFiles().path,
        element: <ImportFilesPage />,
      },
    ],
  };
};
